var map = {
	"./": [
		280
	],
	"./Dividends": [
		324,
		0,
		1,
		2,
		4,
		24
	],
	"./Dividends/": [
		324,
		0,
		1,
		2,
		4,
		24
	],
	"./Dividends/Dividends": [
		742,
		0,
		1,
		2,
		4,
		38
	],
	"./Dividends/Dividends.route": [
		444
	],
	"./Dividends/Dividends.route.tsx": [
		444
	],
	"./Dividends/Dividends.styled": [
		713,
		79
	],
	"./Dividends/Dividends.styled.tsx": [
		713,
		79
	],
	"./Dividends/Dividends.tsx": [
		742,
		0,
		1,
		2,
		4,
		38
	],
	"./Dividends/components/Allocate": [
		714,
		0,
		4,
		44
	],
	"./Dividends/components/Allocate.styled": [
		698,
		65
	],
	"./Dividends/components/Allocate.styled.tsx": [
		698,
		65
	],
	"./Dividends/components/Allocate.tsx": [
		714,
		0,
		4,
		44
	],
	"./Dividends/components/CustomCountdown": [
		716,
		77
	],
	"./Dividends/components/CustomCountdown.tsx": [
		716,
		77
	],
	"./Dividends/components/Deallocate": [
		715,
		0,
		4,
		45
	],
	"./Dividends/components/Deallocate.styled": [
		699,
		66
	],
	"./Dividends/components/Deallocate.styled.tsx": [
		699,
		66
	],
	"./Dividends/components/Deallocate.tsx": [
		715,
		0,
		4,
		45
	],
	"./Dividends/index": [
		324,
		0,
		1,
		2,
		4,
		24
	],
	"./Dividends/index.tsx": [
		324,
		0,
		1,
		2,
		4,
		24
	],
	"./EcosystemPartners": [
		325,
		15,
		26
	],
	"./EcosystemPartners/": [
		325,
		15,
		26
	],
	"./EcosystemPartners/EcosystemPartners": [
		743,
		15
	],
	"./EcosystemPartners/EcosystemPartners.route": [
		445
	],
	"./EcosystemPartners/EcosystemPartners.route.tsx": [
		445
	],
	"./EcosystemPartners/EcosystemPartners.styled": [
		744,
		57
	],
	"./EcosystemPartners/EcosystemPartners.styled.tsx": [
		744,
		57
	],
	"./EcosystemPartners/EcosystemPartners.tsx": [
		743,
		15
	],
	"./EcosystemPartners/index": [
		325,
		15,
		26
	],
	"./EcosystemPartners/index.ts": [
		325,
		15,
		26
	],
	"./LPPosition": [
		326,
		0,
		1,
		2,
		3,
		20
	],
	"./LPPosition/": [
		326,
		0,
		1,
		2,
		3,
		20
	],
	"./LPPosition/LPPosition": [
		737,
		0,
		1,
		2,
		3,
		34
	],
	"./LPPosition/LPPosition.route": [
		446
	],
	"./LPPosition/LPPosition.route.tsx": [
		446
	],
	"./LPPosition/LPPosition.styled": [
		717,
		88
	],
	"./LPPosition/LPPosition.styled.tsx": [
		717,
		88
	],
	"./LPPosition/LPPosition.tsx": [
		737,
		0,
		1,
		2,
		3,
		34
	],
	"./LPPosition/components/Boost": [
		722,
		0,
		3,
		4,
		48
	],
	"./LPPosition/components/Boost.styled": [
		704,
		67
	],
	"./LPPosition/components/Boost.styled.tsx": [
		704,
		67
	],
	"./LPPosition/components/Boost.tsx": [
		722,
		0,
		3,
		4,
		48
	],
	"./LPPosition/components/CustomCountDown": [
		724,
		78
	],
	"./LPPosition/components/CustomCountDown.tsx": [
		724,
		78
	],
	"./LPPosition/components/Deposit": [
		723,
		0,
		1,
		3,
		4,
		41
	],
	"./LPPosition/components/Deposit.styled": [
		705,
		68
	],
	"./LPPosition/components/Deposit.styled.tsx": [
		705,
		68
	],
	"./LPPosition/components/Deposit.tsx": [
		723,
		0,
		1,
		3,
		4,
		41
	],
	"./LPPosition/components/LockDuration": [
		718,
		0,
		3,
		40
	],
	"./LPPosition/components/LockDuration.styled": [
		700,
		69
	],
	"./LPPosition/components/LockDuration.styled.tsx": [
		700,
		69
	],
	"./LPPosition/components/LockDuration.tsx": [
		718,
		0,
		3,
		40
	],
	"./LPPosition/components/Merge": [
		726,
		0,
		3,
		42
	],
	"./LPPosition/components/Merge.styled": [
		707,
		70
	],
	"./LPPosition/components/Merge.styled.tsx": [
		707,
		70
	],
	"./LPPosition/components/Merge.tsx": [
		726,
		0,
		3,
		42
	],
	"./LPPosition/components/RenewDuration": [
		725,
		0,
		3,
		39
	],
	"./LPPosition/components/RenewDuration.styled": [
		706,
		71
	],
	"./LPPosition/components/RenewDuration.styled.tsx": [
		706,
		71
	],
	"./LPPosition/components/RenewDuration.tsx": [
		725,
		0,
		3,
		39
	],
	"./LPPosition/components/SplitPos": [
		720,
		0,
		3,
		43
	],
	"./LPPosition/components/SplitPos.styled": [
		702,
		72
	],
	"./LPPosition/components/SplitPos.styled.tsx": [
		702,
		72
	],
	"./LPPosition/components/SplitPos.tsx": [
		720,
		0,
		3,
		43
	],
	"./LPPosition/components/TransferPos": [
		719,
		0,
		3,
		49
	],
	"./LPPosition/components/TransferPos.styled": [
		701,
		73
	],
	"./LPPosition/components/TransferPos.styled.tsx": [
		701,
		73
	],
	"./LPPosition/components/TransferPos.tsx": [
		719,
		0,
		3,
		49
	],
	"./LPPosition/components/Unboost": [
		721,
		0,
		3,
		50
	],
	"./LPPosition/components/Unboost.styled": [
		703,
		74
	],
	"./LPPosition/components/Unboost.styled.tsx": [
		703,
		74
	],
	"./LPPosition/components/Unboost.tsx": [
		721,
		0,
		3,
		50
	],
	"./LPPosition/index": [
		326,
		0,
		1,
		2,
		3,
		20
	],
	"./LPPosition/index.tsx": [
		326,
		0,
		1,
		2,
		3,
		20
	],
	"./LandingPage": [
		327,
		0,
		14,
		27
	],
	"./LandingPage/": [
		327,
		0,
		14,
		27
	],
	"./LandingPage/LandingPage": [
		758,
		0,
		14
	],
	"./LandingPage/LandingPage.hard": [
		772,
		89
	],
	"./LandingPage/LandingPage.hard.tsx": [
		772,
		89
	],
	"./LandingPage/LandingPage.route": [
		447
	],
	"./LandingPage/LandingPage.route.tsx": [
		447
	],
	"./LandingPage/LandingPage.styled": [
		745,
		90
	],
	"./LandingPage/LandingPage.styled.tsx": [
		745,
		90
	],
	"./LandingPage/LandingPage.tsx": [
		758,
		0,
		14
	],
	"./LandingPage/components/AirdopRules.styled": [
		727,
		91
	],
	"./LandingPage/components/AirdopRules.styled.tsx": [
		727,
		91
	],
	"./LandingPage/components/AirdropRules": [
		746,
		51
	],
	"./LandingPage/components/AirdropRules.tsx": [
		746,
		51
	],
	"./LandingPage/index": [
		327,
		0,
		14,
		27
	],
	"./LandingPage/index.tsx": [
		327,
		0,
		14,
		27
	],
	"./LaunchPad": [
		328,
		0,
		8,
		7,
		25
	],
	"./LaunchPad/": [
		328,
		0,
		8,
		7,
		25
	],
	"./LaunchPad/Countdown": [
		760,
		92
	],
	"./LaunchPad/Countdown.tsx": [
		760,
		92
	],
	"./LaunchPad/LaunchPad": [
		738,
		0,
		8,
		7,
		52
	],
	"./LaunchPad/LaunchPad.route": [
		448
	],
	"./LaunchPad/LaunchPad.route.tsx": [
		448
	],
	"./LaunchPad/LaunchPad.styled": [
		728,
		80
	],
	"./LaunchPad/LaunchPad.styled.tsx": [
		728,
		80
	],
	"./LaunchPad/LaunchPad.tsx": [
		738,
		0,
		8,
		7,
		52
	],
	"./LaunchPad/Launhpad.hard": [
		773,
		93
	],
	"./LaunchPad/Launhpad.hard.tsx": [
		773,
		93
	],
	"./LaunchPad/index": [
		328,
		0,
		8,
		7,
		25
	],
	"./LaunchPad/index.tsx": [
		328,
		0,
		8,
		7,
		25
	],
	"./LaunchPadDetail": [
		329,
		0,
		8,
		7,
		12,
		28
	],
	"./LaunchPadDetail/": [
		329,
		0,
		8,
		7,
		12,
		28
	],
	"./LaunchPadDetail/LaunchPad.hard": [
		774,
		56
	],
	"./LaunchPadDetail/LaunchPad.hard.tsx": [
		774,
		56
	],
	"./LaunchPadDetail/LaunchPadDetail": [
		759,
		0,
		8,
		7,
		12
	],
	"./LaunchPadDetail/LaunchPadDetail.route": [
		449
	],
	"./LaunchPadDetail/LaunchPadDetail.route.tsx": [
		449
	],
	"./LaunchPadDetail/LaunchPadDetail.styled": [
		747,
		81
	],
	"./LaunchPadDetail/LaunchPadDetail.styled.tsx": [
		747,
		81
	],
	"./LaunchPadDetail/LaunchPadDetail.tsx": [
		759,
		0,
		8,
		7,
		12
	],
	"./LaunchPadDetail/index": [
		329,
		0,
		8,
		7,
		12,
		28
	],
	"./LaunchPadDetail/index.tsx": [
		329,
		0,
		8,
		7,
		12,
		28
	],
	"./LeaderBoard": [
		330,
		0,
		1,
		16,
		29
	],
	"./LeaderBoard/": [
		330,
		0,
		1,
		16,
		29
	],
	"./LeaderBoard/LeaderBoard": [
		748,
		0,
		1,
		16
	],
	"./LeaderBoard/LeaderBoard.hard": [
		775,
		94
	],
	"./LeaderBoard/LeaderBoard.hard.tsx": [
		775,
		94
	],
	"./LeaderBoard/LeaderBoard.route": [
		450
	],
	"./LeaderBoard/LeaderBoard.route.tsx": [
		450
	],
	"./LeaderBoard/LeaderBoard.styled": [
		749,
		82
	],
	"./LeaderBoard/LeaderBoard.styled.tsx": [
		749,
		82
	],
	"./LeaderBoard/LeaderBoard.tsx": [
		748,
		0,
		1,
		16
	],
	"./LeaderBoard/index": [
		330,
		0,
		1,
		16,
		29
	],
	"./LeaderBoard/index.tsx": [
		330,
		0,
		1,
		16,
		29
	],
	"./Liquidity": [
		331,
		0,
		1,
		2,
		3,
		21
	],
	"./Liquidity/": [
		331,
		0,
		1,
		2,
		3,
		21
	],
	"./Liquidity/Liquidity": [
		739,
		0,
		1,
		2,
		3,
		35
	],
	"./Liquidity/Liquidity.hard": [
		776,
		95
	],
	"./Liquidity/Liquidity.hard.tsx": [
		776,
		95
	],
	"./Liquidity/Liquidity.route": [
		451
	],
	"./Liquidity/Liquidity.route.tsx": [
		451
	],
	"./Liquidity/Liquidity.styled": [
		729,
		58
	],
	"./Liquidity/Liquidity.styled.tsx": [
		729,
		58
	],
	"./Liquidity/Liquidity.tsx": [
		739,
		0,
		1,
		2,
		3,
		35
	],
	"./Liquidity/components/Unbind": [
		730,
		0,
		1,
		2,
		9,
		46
	],
	"./Liquidity/components/Unbind.styled": [
		708,
		75
	],
	"./Liquidity/components/Unbind.styled.tsx": [
		708,
		75
	],
	"./Liquidity/components/Unbind.tsx": [
		730,
		0,
		1,
		2,
		9,
		46
	],
	"./Liquidity/index": [
		331,
		0,
		1,
		2,
		3,
		21
	],
	"./Liquidity/index.tsx": [
		331,
		0,
		1,
		2,
		3,
		21
	],
	"./LiquidityDetail": [
		332,
		0,
		1,
		2,
		9,
		23
	],
	"./LiquidityDetail/": [
		332,
		0,
		1,
		2,
		9,
		23
	],
	"./LiquidityDetail/LiquidityDetail": [
		740,
		0,
		1,
		2,
		9,
		37
	],
	"./LiquidityDetail/LiquidityDetail.hard": [
		777,
		96
	],
	"./LiquidityDetail/LiquidityDetail.hard.tsx": [
		777,
		96
	],
	"./LiquidityDetail/LiquidityDetail.route": [
		452
	],
	"./LiquidityDetail/LiquidityDetail.route.tsx": [
		452
	],
	"./LiquidityDetail/LiquidityDetail.styled": [
		731,
		59
	],
	"./LiquidityDetail/LiquidityDetail.styled.tsx": [
		731,
		59
	],
	"./LiquidityDetail/LiquidityDetail.tsx": [
		740,
		0,
		1,
		2,
		9,
		37
	],
	"./LiquidityDetail/components/Unbind": [
		732,
		0,
		1,
		2,
		9,
		47
	],
	"./LiquidityDetail/components/Unbind.styled": [
		709,
		76
	],
	"./LiquidityDetail/components/Unbind.styled.tsx": [
		709,
		76
	],
	"./LiquidityDetail/components/Unbind.tsx": [
		732,
		0,
		1,
		2,
		9,
		47
	],
	"./LiquidityDetail/index": [
		332,
		0,
		1,
		2,
		9,
		23
	],
	"./LiquidityDetail/index.tsx": [
		332,
		0,
		1,
		2,
		9,
		23
	],
	"./LiquidityPartner": [
		260,
		11,
		19
	],
	"./LiquidityPartner/": [
		260,
		11,
		19
	],
	"./LiquidityPartner/LiquidityPartner": [
		750,
		11
	],
	"./LiquidityPartner/LiquidityPartner.route": [
		453
	],
	"./LiquidityPartner/LiquidityPartner.route.tsx": [
		453
	],
	"./LiquidityPartner/LiquidityPartner.styled": [
		751,
		62
	],
	"./LiquidityPartner/LiquidityPartner.styled.tsx": [
		751,
		62
	],
	"./LiquidityPartner/LiquidityPartner.tsx": [
		750,
		11
	],
	"./LiquidityPartner/index": [
		260,
		11,
		19
	],
	"./LiquidityPartner/index.tsx": [
		260,
		11,
		19
	],
	"./LiquidityPartnerDetail": [
		439,
		17,
		32
	],
	"./LiquidityPartnerDetail/": [
		439,
		17,
		32
	],
	"./LiquidityPartnerDetail/LiquidityPartnerDetail": [
		756,
		17
	],
	"./LiquidityPartnerDetail/LiquidityPartnerDetail.route": [
		454
	],
	"./LiquidityPartnerDetail/LiquidityPartnerDetail.route.tsx": [
		454
	],
	"./LiquidityPartnerDetail/LiquidityPartnerDetail.styled": [
		755,
		83
	],
	"./LiquidityPartnerDetail/LiquidityPartnerDetail.styled.tsx": [
		755,
		83
	],
	"./LiquidityPartnerDetail/LiquidityPartnerDetail.tsx": [
		756,
		17
	],
	"./LiquidityPartnerDetail/index": [
		439,
		17,
		32
	],
	"./LiquidityPartnerDetail/index.tsx": [
		439,
		17,
		32
	],
	"./MainRoute": [
		229
	],
	"./MainRoute/": [
		229
	],
	"./MainRoute/MainRoute": [
		353
	],
	"./MainRoute/MainRoute.enhance": [
		354
	],
	"./MainRoute/MainRoute.enhance.tsx": [
		354
	],
	"./MainRoute/MainRoute.inteface": [
		778,
		97
	],
	"./MainRoute/MainRoute.inteface.ts": [
		778,
		97
	],
	"./MainRoute/MainRoute.tsx": [
		353
	],
	"./MainRoute/index": [
		229
	],
	"./MainRoute/index.ts": [
		229
	],
	"./Profile": [
		440,
		5,
		6,
		31
	],
	"./Profile/": [
		440,
		5,
		6,
		31
	],
	"./Profile/Profile": [
		517,
		5,
		6,
		33
	],
	"./Profile/Profile.hard": [
		692,
		98
	],
	"./Profile/Profile.hard.tsx": [
		692,
		98
	],
	"./Profile/Profile.route": [
		455
	],
	"./Profile/Profile.route.tsx": [
		455
	],
	"./Profile/Profile.styled": [
		733,
		99
	],
	"./Profile/Profile.styled.tsx": [
		733,
		99
	],
	"./Profile/Profile.tsx": [
		517,
		5,
		6,
		33
	],
	"./Profile/components": [
		438,
		5,
		6,
		18
	],
	"./Profile/components/": [
		438,
		5,
		6,
		18
	],
	"./Profile/components/AccountSetting": [
		712,
		5,
		6
	],
	"./Profile/components/AccountSetting.entities": [
		779,
		100
	],
	"./Profile/components/AccountSetting.entities.tsx": [
		779,
		100
	],
	"./Profile/components/AccountSetting.styled": [
		752,
		101
	],
	"./Profile/components/AccountSetting.styled.tsx": [
		752,
		101
	],
	"./Profile/components/AccountSetting.tsx": [
		712,
		5,
		6
	],
	"./Profile/components/ProfileContent": [
		693,
		5,
		6,
		18
	],
	"./Profile/components/ProfileContent.styled": [
		710,
		102
	],
	"./Profile/components/ProfileContent.styled.tsx": [
		710,
		102
	],
	"./Profile/components/ProfileContent.tsx": [
		693,
		5,
		6,
		18
	],
	"./Profile/components/ProfileSibar.entities": [
		780,
		103
	],
	"./Profile/components/ProfileSibar.entities.tsx": [
		780,
		103
	],
	"./Profile/components/ProfileSideBar": [
		688,
		63
	],
	"./Profile/components/ProfileSideBar.styled": [
		691,
		104
	],
	"./Profile/components/ProfileSideBar.styled.tsx": [
		691,
		104
	],
	"./Profile/components/ProfileSideBar.tsx": [
		688,
		63
	],
	"./Profile/components/SocialLink": [
		687,
		84
	],
	"./Profile/components/SocialLink.styled": [
		694,
		105
	],
	"./Profile/components/SocialLink.styled.tsx": [
		694,
		105
	],
	"./Profile/components/SocialLink.tsx": [
		687,
		84
	],
	"./Profile/components/UploadAvatar": [
		753,
		53
	],
	"./Profile/components/UploadAvatar.entities": [
		781,
		106
	],
	"./Profile/components/UploadAvatar.entities.tsx": [
		781,
		106
	],
	"./Profile/components/UploadAvatar.styled": [
		734,
		107
	],
	"./Profile/components/UploadAvatar.styled.tsx": [
		734,
		107
	],
	"./Profile/components/UploadAvatar.tsx": [
		753,
		53
	],
	"./Profile/components/WalletAddress": [
		689,
		54
	],
	"./Profile/components/WalletAddress.hard": [
		696,
		108
	],
	"./Profile/components/WalletAddress.hard.tsx": [
		696,
		108
	],
	"./Profile/components/WalletAddress.styled": [
		695,
		109
	],
	"./Profile/components/WalletAddress.styled.tsx": [
		695,
		109
	],
	"./Profile/components/WalletAddress.tsx": [
		689,
		54
	],
	"./Profile/components/index": [
		438,
		5,
		6,
		18
	],
	"./Profile/components/index.tsx": [
		438,
		5,
		6,
		18
	],
	"./Profile/index": [
		440,
		5,
		6,
		31
	],
	"./Profile/index.tsx": [
		440,
		5,
		6,
		31
	],
	"./Swap": [
		333,
		0,
		10,
		1,
		2,
		22
	],
	"./Swap/": [
		333,
		0,
		10,
		1,
		2,
		22
	],
	"./Swap/Swap": [
		741,
		0,
		10,
		1,
		2,
		36
	],
	"./Swap/Swap.hard": [
		680,
		2
	],
	"./Swap/Swap.hard.tsx": [
		680,
		2
	],
	"./Swap/Swap.route": [
		456
	],
	"./Swap/Swap.route.tsx": [
		456
	],
	"./Swap/Swap.styled": [
		735,
		60
	],
	"./Swap/Swap.styled.tsx": [
		735,
		60
	],
	"./Swap/Swap.tsx": [
		741,
		0,
		10,
		1,
		2,
		36
	],
	"./Swap/Swap.utils": [
		679,
		110
	],
	"./Swap/Swap.utils.tsx": [
		679,
		110
	],
	"./Swap/components/BridgePopUp": [
		685,
		55
	],
	"./Swap/components/BridgePopUp.styled": [
		682,
		111
	],
	"./Swap/components/BridgePopUp.styled.tsx": [
		682,
		111
	],
	"./Swap/components/BridgePopUp.tsx": [
		685,
		55
	],
	"./Swap/components/DropDown": [
		782,
		64
	],
	"./Swap/components/DropDown.styled": [
		757,
		112
	],
	"./Swap/components/DropDown.styled.tsx": [
		757,
		112
	],
	"./Swap/components/DropDown.tsx": [
		782,
		64
	],
	"./Swap/components/SelectToken": [
		690,
		0,
		1,
		2,
		9,
		85
	],
	"./Swap/components/SelectToken.styled": [
		686,
		113
	],
	"./Swap/components/SelectToken.styled.tsx": [
		686,
		113
	],
	"./Swap/components/SelectToken.tsx": [
		690,
		0,
		1,
		2,
		9,
		85
	],
	"./Swap/components/Setting": [
		684,
		61
	],
	"./Swap/components/Setting.styled": [
		681,
		114
	],
	"./Swap/components/Setting.styled.tsx": [
		681,
		114
	],
	"./Swap/components/Setting.tsx": [
		684,
		61
	],
	"./Swap/components/SwapChart": [
		736,
		10,
		86
	],
	"./Swap/components/SwapChart.styled": [
		711,
		115
	],
	"./Swap/components/SwapChart.styled.tsx": [
		711,
		115
	],
	"./Swap/components/SwapChart.tsx": [
		736,
		10,
		86
	],
	"./Swap/index": [
		333,
		0,
		10,
		1,
		2,
		22
	],
	"./Swap/index.tsx": [
		333,
		0,
		10,
		1,
		2,
		22
	],
	"./index": [
		280
	],
	"./index.ts": [
		280
	],
	"./xGalo": [
		334,
		4,
		13,
		30
	],
	"./xGalo/": [
		334,
		4,
		13,
		30
	],
	"./xGalo/index": [
		334,
		4,
		13,
		30
	],
	"./xGalo/index.ts": [
		334,
		4,
		13,
		30
	],
	"./xGalo/xGalo": [
		761,
		4,
		13
	],
	"./xGalo/xGalo.route": [
		457
	],
	"./xGalo/xGalo.route.tsx": [
		457
	],
	"./xGalo/xGalo.styled": [
		754,
		87
	],
	"./xGalo/xGalo.styled.tsx": [
		754,
		87
	],
	"./xGalo/xGalo.tsx": [
		761,
		4,
		13
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 862;
module.exports = webpackAsyncContext;